import Vue from 'vue'
import VueRouter from 'vue-router'

import HomePage from './components/HomePage.vue';
import LoginPage from './components/LoginPage.vue';
import SimcardList from './components/SimcardList.vue';
import TagList from './components/TagList.vue';
import ActRequests from './components/ActRequests.vue';
import CookiePolicy from './components/CookiePolicy.vue';

import userServ from './services/user.service';

Vue.use(VueRouter);

const router = new VueRouter({
    routes: [{
            path: '/',
            component: HomePage,
            children: [{
                    path: '',
                    component: SimcardList,
                },
                {
                    path: 'simcards',
                    component: SimcardList,
                },
                {
                    path: 'tags',
                    component: TagList
                },
                {
                    path: 'act-requests',
                    component: ActRequests,
                },
                {
                    path: 'cookie-policy',
                    component: CookiePolicy,
                }
            ]
        },
        {
            path: '/login',
            component: LoginPage,
        },
        { path: '*', redirect: '/' }
    ]
});

router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/login'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = userServ.getToken();

    if (authRequired && !loggedIn) {
        return next('/login');
    }

    next();
})

export default router;